<ng-container *ngIf="fieldTypeSpecs; else loadingTemplate">
  <div class="d-flex justify-content-between">
    <div class="input-group">
      <label for="number-of-levels" class="form-label me-3 fs-11"
        >Number of Levels:</label
      >
      <ng-select
        id="type"
        autocomplete="off"
        [items]="levels"
        [searchable]="false"
        [clearable]="false"
        bindLabel="label"
        bindValue="value"
        style="max-width: 50px"
        [ngModel]="fieldTypeSpecs.numbLevels"
        (ngModelChange)="onLevelsValueChange($event)">
      </ng-select>
    </div>
    <button
      class="btn-reset fw-600 fs-11 ms-4"
      style="white-space: nowrap"
      (click)="editLevelNamesModal.modal.open()">
      <i class="bi bi-pencil color-tertiary fs-12 me-1"></i> Edit Level Names
    </button>
    <app-edit-level-names-modal
      [levelNames]="fieldTypeSpecs.levelNames"
      (levelsUpdated)="handleLevelNamesEvent($event)"
      #editLevelNamesModal></app-edit-level-names-modal>
  </div>
  <div class="p-2">
    <ng-container
      *ngFor="let competency of fieldTypeSpecs.competencies; index as ci">
      <div class="comptency-wrapper mt-3">
        <div class="d-flex mb-2 justify-content-between align-items-center">
          <div class="fw-600 fs-16">{{ competency.title }}</div>
          <button
            class="btn btn-link"
            #tooltip="ngbTooltip"
            (click)="tooltip.close()"
            [autoClose]="'outside'"
            ngbTooltip="Edit Competency"
            (click)="editCompetencyModal.modal.open()">
            <i class="bi bi-pencil"></i>
          </button>
        </div>

        <div style="position: relative; margin-bottom: 20px">
          <div class="levels-wrapper">
            <ng-container *ngFor="let gi of competency.gis; index as l">
              <div class="level-item">
                <div class="level-header">
                  {{ fieldTypeSpecs.levelNames[l] }}
                </div>
                <div class="level-content">
                  {{ gi }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <app-edit-competency-modal
        [levelNames]="fieldTypeSpecs.levelNames"
        [competency]="competency"
        [canDeleteCompetency]="canDeleteCompetency"
        [competencyIndex]="ci"
        (competencyUpdated)="handleCompetencyContentEvent($event)"
        (competencyDeleted)="deleteCompetency($event)"
        #editCompetencyModal></app-edit-competency-modal>
    </ng-container>
    <div class="text-end">
      <button
        (click)="addCompetency()"
        type="button"
        class="btn btn-link fw-bold xp-0 text-decoration-none">
        <i class="bi bi-plus"></i>Add Competency
      </button>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="w-100" style="height: 200px; position: relative">
    <app-loader />
  </div>
</ng-template>
